import React, { useEffect, useState } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import axiosClient from "../../axios-client";

function Companies() {
  const [currentPage, setCurrentPage] = useState(1);
  const companiesPerPage = 10; // 10 companies per page
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]); // State for companies data
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const navigate = useNavigate(); // Hook for navigation

  // Calculate total pages
  const totalPages = Math.ceil(companies.length / companiesPerPage);

  // Get the index range of the companies to display on the current page
  const indexOfLastCompany = currentPage * companiesPerPage;
  const indexOfFirstCompany = indexOfLastCompany - companiesPerPage;
  const currentCompanies = companies
    .filter((company) =>
      company.companyName.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .slice(indexOfFirstCompany, indexOfLastCompany);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleBackClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    // Fetch companies data from API
    const fetchCompanies = async () => {
      try {
        setLoading(true); // Start loading
        const response = await axiosClient.get("/company/getallcompanies");
        setCompanies(response.data); // Update companies data
      } catch (error) {
        console.error("Error fetching companies:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchCompanies();
  }, []);

  // Handle navigation with company data
  const handleCompanyClick = (company) => {
    navigate("/Company-details", { state: { company } }); // Pass company data using state
    console.log(company);
  };

  // Calculate the range of pagination buttons to display
  const maxButtons = 10;
  const startPage = Math.floor((currentPage - 1) / maxButtons) * maxButtons + 1;
  const endPage = Math.min(startPage + maxButtons - 1, totalPages);

  return (
    <>
      <div className="min-h-screen bg-blue-50">
        <div className="p-8" style={{ width: "100%" }}>
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold">Companies</h1>
            <input
              type="text"
              placeholder="Search companies..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="px-4 py-2 border rounded"
            />
          </div>
          <div className="overflow-hidden rounded-lg border border-gray-300 bg-white">
            <div className="overflow-x-auto">
              {loading ? (
                <div className="text-center py-6">Loading companies...</div>
              ) : (
                <table className="min-w-full w-full table-auto">
                  <thead>
                    <tr className="text-left border-b border-gray-300">
                      <th className="py-3 px-2 sm:px-4">Companies</th>
                      <th className="py-3 px-2 sm:px-40 text-center sm:text-left">
                        HQ
                      </th>
                      <th className="py-3 px-2 sm:pr-14">Employee Strength</th>
                      <th className="py-3 px-2 sm:pl-2 sm:pr-60 text-left">
                        Market Relevance
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentCompanies.map((company, index) => (
                      <tr key={index} className="border-b border-gray-300">
                        <td className="py-1 px-0 text-pink-500 text-center company2">
                          <button
                            onClick={() => handleCompanyClick(company)} // Pass company data on click
                            className="hover:underline bg-transparent border-none text-pink-500 cursor-pointer"
                          >
                            {company.companyName}
                          </button>
                        </td>
                        <td className="py-3 px-16 company1">
                          {company.headquarter}
                        </td>
                        <td className="py-1 px-6 pr-40 text-center company1">
                          {company.employeeSize}
                        </td>
                        <td className="py-5 px-14">{company.marketRelevance}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-center mt-6 space-x-1">
            <button
              className="flex items-center px-2 py-1 bg-white border rounded"
              onClick={handleBackClick}
              disabled={currentPage === 1}
            >
              <MdKeyboardArrowLeft className="mr-2" />
              Back
            </button>
            {[...Array(endPage - startPage + 1)].map((_, index) => (
              <button
                key={index}
                className={`px-3 py-1 border rounded ${
                  currentPage === startPage + index
                    ? "bg-black text-white"
                    : "bg-white"
                }`}
                onClick={() => handlePageChange(startPage + index)}
              >
                {startPage + index}
              </button>
            ))}
            <button
              className="flex justify-between items-center px-3 py-1 bg-white border rounded"
              onClick={handleNextClick}
              disabled={currentPage === totalPages}
            >
              <span>Next</span>
              <MdKeyboardArrowRight className="ml-2" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Companies;
